import weekIcon from 'src/public/img/illustration-blank-canvas.svg';
import congratulationsIcon from 'src/public/img/illustration-smiley-face.svg';

import { ProgramSharedStep, ProgramWeekEnum } from 'src/modules/programs/models/programs';

import { CBTProgramStepProps } from '../../models/cbtProgram';
import { AvoidingEmotionsStep } from '../stepComponents/AvoidingEmotionsStep';
import { BehavioursPracticeStep } from '../stepComponents/BehavioursPracticeStep';
import { ConsequencesStep } from '../stepComponents/ConsequencesStep';
import { ExamplesStep } from '../stepComponents/ExamplesStep';
import { HowDidCognitiveFlexibilityGoStep } from '../stepComponents/HowDidCognitiveFlexibilityGoStep';
import { SomeRemindersStep } from '../stepComponents/SomeRemindersStep';
import { ThisSeemsDifficultStep } from '../stepComponents/ThisSeemsDifficultStep';
import { WhatAreYourBehaviorsStep } from '../stepComponents/WhatAreYourBehaviorsStep';
import { WhatCanWeDoDifferentlyStep } from '../stepComponents/WhatCanWeDoDifferentlyStep';
import { WhyDoWeAvoidStep } from '../stepComponents/WhyDoWeAvoidStep';
import { WhyFocusOnBehaviorsStep } from '../stepComponents/WhyFocusOnBehaviors';
import { CBTProgramWeekSixStep } from './weekSix';

const steps: (ProgramSharedStep | CBTProgramWeekSixStep)[] = [
    ProgramSharedStep.WellbeingCheckInStep,
    ProgramSharedStep.WellbeingScoreStep,
    ProgramSharedStep.FeedbackStep,
    CBTProgramWeekSixStep.HowDidCognitiveFlexibilityGoStep,
    CBTProgramWeekSixStep.WhyFocusOnBehaviorsStep,
    CBTProgramWeekSixStep.SomeRemindersStep,
    CBTProgramWeekSixStep.AvoidingEmotionsStep,
    CBTProgramWeekSixStep.WhatAreYourBehaviorsStep,
    CBTProgramWeekSixStep.ConsequencesStep,
    CBTProgramWeekSixStep.WhyDoWeAvoidStep,
    CBTProgramWeekSixStep.WhatCanWeDoDifferentlyStep,
    CBTProgramWeekSixStep.ExamplesStep,
    CBTProgramWeekSixStep.ThisSeemsDifficultStep,
    ProgramSharedStep.PlanStep,
    ProgramSharedStep.CongratulationsStep,
];

const stepsProps: CBTProgramStepProps[] = [
    {
        id: CBTProgramWeekSixStep.HowDidCognitiveFlexibilityGoStep,
        component: HowDidCognitiveFlexibilityGoStep,
        tooltip: 'How did cognitive flexibility go last week?',
        noButtons: true,
    },
    {
        id: CBTProgramWeekSixStep.WhyFocusOnBehaviorsStep,
        component: WhyFocusOnBehaviorsStep,
        tooltip: 'Why focus on behaviors?',
    },
    {
        id: CBTProgramWeekSixStep.SomeRemindersStep,
        component: SomeRemindersStep,
        tooltip: 'Some reminders about emotions and behaviors',
    },
    {
        id: CBTProgramWeekSixStep.AvoidingEmotionsStep,
        component: AvoidingEmotionsStep,
        tooltip: 'Avoiding emotions',
    },
    {
        id: CBTProgramWeekSixStep.WhatAreYourBehaviorsStep,
        component: WhatAreYourBehaviorsStep,
        tooltip: 'What are your behaviors?',
        noButtons: true,
    },
    {
        id: CBTProgramWeekSixStep.ConsequencesStep,
        component: ConsequencesStep,
        tooltip: 'Consequences',
        noButtons: true,
    },
    {
        id: CBTProgramWeekSixStep.WhyDoWeAvoidStep,
        component: WhyDoWeAvoidStep,
        tooltip: 'Why do we avoid?',
    },
    {
        id: CBTProgramWeekSixStep.WhatCanWeDoDifferentlyStep,
        component: WhatCanWeDoDifferentlyStep,
        tooltip: 'What can we do differently?',
    },
    {
        id: CBTProgramWeekSixStep.ExamplesStep,
        component: ExamplesStep,
        tooltip: 'Examples of alternative behaviors',
    },
    {
        id: CBTProgramWeekSixStep.ThisSeemsDifficultStep,
        component: ThisSeemsDifficultStep,
        tooltip: 'This seems difficult!',
    },
    {
        id: ProgramSharedStep.PlanStep,
        component: BehavioursPracticeStep,
        tooltip: 'This week',
    },
];

const t = (key: string) => `cbt:week-6.data.${key}`;

export const weekSixData = {
    id: ProgramWeekEnum.WeekSix,
    weekNumber: 5,
    readableWeekNumber: 6,
    iconUrl: weekIcon,
    congratulationsIconUrl: congratulationsIcon,
    title: t('title'),
    congratulationsSneakPeek: t('congratulationsSneakPeek'),
    feedbackPlaceholder: t('feedbackPlaceholder'),
    greetingModalContent: t('greetingModalContent'),
    steps,
    stepsProps,
};
